import clsx from "clsx";
import { Button, type ButtonProps, type ButtonRenderProps } from "react-aria-components";
import styles from "./AriaButton.module.css";
import { type ReactNode } from "react";
import { LoadingIndicator } from "../../../ui-components/LoadingIndicator/LoadingIndicator";

export interface AriaButtonProps extends ButtonProps {
  color?: "brand" | "destructive" | "gray" | "green";
  variant?: "primary" | "secondary" | "tertiary" | "quiet";
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  isLoading?: boolean;
  fullWidth?: boolean;
  children?: ReactNode | ((renderProps: ButtonRenderProps) => ReactNode);
}

export function AriaButton({ className, color, variant = "primary", size = "md", isLoading, fullWidth, children, ...props }: AriaButtonProps) {
  color = color || (variant === "primary" ? "brand" : "gray");

  return (
    <Button
      {...props}
      className={clsx(
        styles.reactAriaButton,
        styles[variant],
        styles[`${variant}-${color}`],
        styles[size],
        isLoading && styles.loading,
        fullWidth && styles.fullWidth,
        className
      )}
    >
      {isLoading ? (
        <LoadingIndicator
          className={styles.loadingIndicator}
          style={{
            color: variant === "primary" ? "var(--color-base-white)" : `var(--${color}-600)`,
          }}
        />
      ) : typeof children === "function" ? (
        (props: ButtonRenderProps) => children(props)
      ) : (
        children
      )}
    </Button>
  );
}
